import React from 'react';

import EmptyState from 'shared/empty_state';
import NylasGrant from 'components/nylas/v3/grant';
import * as providers from 'components/nylas/v3/providers';
import * as scopes from 'components/nylas/v3/scopes';

import type { Props as NylasGrantProps } from 'components/nylas/v3/grant';

interface Props {
  nylas: NylasGrantProps;
}

export default function CrmIntegrationSettings({ nylas }: Props) {
  return (
    <div className="d-flex flex-column gap-3">
      <h5>Connected Providers</h5>

      {!nylas.grant && <>
        <EmptyState
          bodyText="To automatically log emails as CRM Activities, connect an email provider from the list below."
          header="No Providers Connected"
        />
        <h6>Available Providers</h6>
      </>}

      <div className="border-top pt-3">
        <NylasGrant {...nylas} provider={providers.gmail} scopes={scopes.messageNotifications} />
      </div>
    </div>
  );
}
